import {
  Search,
  List,
  MessageCircle,
  MoreVertical,
  MessagesSquare,
  Paperclip,
  Type,
  Send,
} from "lucide-react";

/* Messaging page tour, ported from the mobile "Messages" mockup.
   The tour only runs for subscribed (Pro) users who already have at least one
   conversation — that gating lives in Messaging.js (useTour autoStart). It is
   rendered inside the "conversation open" view, where both the conversation
   list and the chat pane are mounted (side-by-side on desktop). On mobile that
   view CSS-hides the list, so the three list-oriented steps (search / list /
   first conversation) are marked `desktopOnly` and filtered out — the mobile
   tour focuses on the open chat. Pass isDesktop=true to include the list steps. */
export default function getMessagingTourSteps(isDesktop = true) {
  const steps = [
    {
      desktopOnly: true,
      cardSelector: '[data-tour="ms-search"]',
      targetSelector: '[data-tour="ms-search"]',
      icon: <Search />,
      title: "Search bar",
      text: "Find any conversation by name or keyword.",
    },
    {
      desktopOnly: true,
      cardSelector: '[data-tour="ms-list"]',
      targetSelector: '[data-tour="ms-list"]',
      icon: <List />,
      title: "Messages list",
      text: "All your conversations, newest first, with unread badges.",
    },
    {
      desktopOnly: true,
      cardSelector: '[data-tour="ms-list"]',
      targetSelector: '[data-tour="ms-conv1"]',
      icon: <MessageCircle />,
      title: "Open a chat",
      text: "Tap any conversation in the list to open it.",
    },
    {
      cardSelector: '[data-tour="ms-chatheader"]',
      targetSelector: '[data-tour="ms-menu"]',
      icon: <MoreVertical />,
      title: "Chat options",
      text: "The three-dot menu opens options like Delete Conversation.",
    },
    {
      cardSelector: '[data-tour="ms-messages"]',
      targetSelector: '[data-tour="ms-messages"]',
      icon: <MessagesSquare />,
      title: "Messages",
      text: "Your conversation thread, with read receipts and timestamps.",
    },
    {
      cardSelector: '[data-tour="ms-inputbar"]',
      targetSelector: '[data-tour="ms-attach"]',
      icon: <Paperclip />,
      title: "Attach",
      text: "Attach a photo or file to your message.",
    },
    {
      cardSelector: '[data-tour="ms-inputbar"]',
      targetSelector: '[data-tour="ms-input"]',
      icon: <Type />,
      title: "Type area",
      text: "Write your message here.",
    },
    {
      cardSelector: '[data-tour="ms-inputbar"]',
      targetSelector: '[data-tour="ms-send"]',
      icon: <Send />,
      title: "Send",
      text: "Send your message.",
    },
  ];
  return isDesktop ? steps : steps.filter((s) => !s.desktopOnly);
}
